export default {
  data: {
    include: 'poll_instances',
    exclude: 'options,results,flash_options,visual_settings'
  }
}
